'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;

var _WixStylesColorUtils = require('./WixStylesColorUtils');

var _WixStylesColorUtils2 = _interopRequireDefault(_WixStylesColorUtils);

var _WixStylesFontUtils = require('./WixStylesFontUtils');

var _WixStylesFontUtils2 = _interopRequireDefault(_WixStylesFontUtils);

var _WixStylesNumberUtils = require('./WixStylesNumberUtils');

var _WixStylesNumberUtils2 = _interopRequireDefault(_WixStylesNumberUtils);

var _WixStylesBoolUtils = require('./WixStylesBoolUtils');

var _WixStylesBoolUtils2 = _interopRequireDefault(_WixStylesBoolUtils);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(_ref) {
    var styleParams = _ref.styleParams,
        siteColors = _ref.siteColors,
        siteTextPresets = _ref.siteTextPresets,
        compId = _ref.compId,
        locale = _ref.locale,
        wss = _ref.wss,
        full = _ref.full,
        fullFromSite = _ref.fullFromSite,
        siteOwnerId = _ref.siteOwnerId,
        forceArial = _ref.forceArial;

    var colorStyles = _lodash2.default.omitBy(styleParams.colors || {}, function (v) {
        return _lodash2.default.isEqual(v, { value: "rgba(1,2,3,1)" }) || _lodash2.default.isEqual(v, { rgba: 'rgba(1,2,3,1)' });
    });
    var fontStyles = _lodash2.default.omitBy(styleParams.fonts || {}, function (v) {
        return !v;
    });
    var numberStyles = styleParams.numbers || {};
    var boolStyles = styleParams.booleans || {};
    var googleFontsCssUrl = styleParams.googleFontsCssUrl;

    var colors = _WixStylesColorUtils2.default.getFullColorStyles({ colorStyles: colorStyles, siteColors: siteColors, defaults: wss.defaults.colors });
    var fonts = _WixStylesFontUtils2.default.getFullFontStyles({ fontStyles: fontStyles, siteTextPresets: siteTextPresets, defaults: wss.defaults.fonts, isHebrew: locale === 'he_IL', forceArial: forceArial });
    var numbers = _WixStylesNumberUtils2.default.getFullNumberStyles({ numberStyles: numberStyles });
    var booleans = _WixStylesBoolUtils2.default.getFullBoolStyles({ boolStyles: boolStyles, compId: compId });

    // The following code is the slow upgrade of the new menu settings screen
    var upgrade = false;
    var organization = full.restaurant || full.chain;

    // Stage one - only 1/16 of the users received it
    if (siteOwnerId) {
        if (siteOwnerId.split('').pop() === '6') {

            if (!organization) {
                upgrade = true;
            } else {
                upgrade = !full || !fullFromSite || organization.created > 1464700000000;
            }

            // Stage two - 1/4 of the users received it
        } else if (parseInt(siteOwnerId.split('').pop(), 16) < 8) {

            if (!organization) {
                upgrade = true;
            } else {
                upgrade = !full || !fullFromSite || organization.created > 1471250000000;
            }
        } else {
            // Stage three - All new users
            if (!organization) {
                upgrade = true;
            } else {
                upgrade = !full || !fullFromSite || organization.created > 1472130000000;
            }
        }
    }

    if (upgrade && numbers['wixmenu.menuview'] < 11) {
        numbers['wixmenu.menuview'] += 11;
    }

    return {
        colors: colors,
        fonts: fonts,
        numbers: numbers,
        booleans: booleans,
        googleFontsCssUrl: googleFontsCssUrl
    };
}

exports.default = { parse: parse };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/WixStylesParser.js
// module id = 1011
// module chunks = 0